export default __webpack_public_path__ + "static/media/xls.5f4973c0.svg";